export default __webpack_public_path__ + "static/what-we-do-1-1-967210c12777617605108afb97340a80.jpg";